import { CompositeResponseError } from '@/shared/api/validation'

export function getInvoiceApprovalErrorMessage(err: unknown) {
  if (!(err instanceof CompositeResponseError)) {
    return undefined
  }

  return err.failures.find(x => x.operation === 'approve_invoice')?.reason
}
